module.exports = __webpack_public_path__ + "assets/images/candle.1d4cd46b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/PersonHero/assets/candle.jpg
// module id = 616
// module chunks = 0